import { Injectable }       from '@angular/core';
import { NgbModal }         from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }                          from '../api/api.service';
import { ChargifyStatusModel }                 from '../chargify/models/chargify.status';
import { CompanySettingsModel }                from '../companies/models/company.settings';
import { ConfirmService }                      from '../messages/confirm/confirm.service';
import { IntegrationQuotePricesModel }         from '../integrations/typings/integration.quote-prices';
import { MobileVideoMinutesPurchaseComponent } from './mobile.video-minutes-purchase.component';
import { MobileVideoMinutesQuoteModel }        from './typings/mobile.video-minutes.quote';

@Injectable({
  providedIn: 'root'
})
export class MobileService {
  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private modalService    : NgbModal,
    private translateService: TranslateService
  ) {}

  activate () : Promise<boolean> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
        name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VIDEO_SETTINGS.TITLE')
      }))
      .then(() => this.apiService.get('/company/add_video_minutes'));
  }

  confirmVideoMinutesPurchase ( quote : MobileVideoMinutesQuoteModel ) : Promise<boolean> {
    return this.apiService.get('/purchase_integration_lookups/purchase', [
        quote.agree,
        quote.quantity,
        'video_minutes'
      ]);
  }

  deactivate () : Promise<boolean> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', {
        name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.VIDEO_SETTINGS.TITLE')
      }))
      .then(() => this.apiService.get('/company/remove_video_minutes'));
  }

  getSettings () : Promise<CompanySettingsModel> {
    return this.apiService.get('/company_settings');
  }

  getVideoMinutesQuote ( quote : MobileVideoMinutesQuoteModel ) : Promise<MobileVideoMinutesQuoteModel> {
    return this.apiService.get('/purchase_integration_lookups/quote', [
        quote.quantity,
        'video_minutes'
      ])
      .then(( cost : number ) => {
        return {
          cost,
          quantity: quote.quantity
        } as MobileVideoMinutesQuoteModel;
      });
  }

  getVideoStorageMinutes () : Promise<string> {
    return this.apiService.get('/company/show_video_storage_minutes')
      .then(response => response.storage_minutes);
  }

  purchaseVideoMinutes () : Promise<any> {
    return this.apiService.get('/purchase_integration_lookups/current_lookup_cost/video_minutes')
      .then(( cost : IntegrationQuotePricesModel ) => {
        const modal = this.modalService.open(MobileVideoMinutesPurchaseComponent, {
          windowClass: 'sm-modal'
        });

        modal.componentInstance.cost = cost;

        return modal.result;
      });
  }

  saveSettings ( settings : CompanySettingsModel ) : Promise<CompanySettingsModel> {
    return this.apiService.patch('/company_settings', settings, 'company_setting');
  }

  updateVideoMinutes ( chargify : ChargifyStatusModel ) : Promise<string> {
    return this.apiService.post('/workshop_admin/update_video_storage_minutes', {
        company_id: chargify.id,
        minutes   : chargify.video_storage_minutes
      })
      .then(response => response.storage_minutes);
  }
}
